import React from 'react';
import './styles.scss';

const TextareaItem = ({ placeHolder, onChange, maxLength = 200}) => {
  return <textarea className='survey-textarea' placeholder={placeHolder} onChange={onChange} maxLength={maxLength} />;
};

export default TextareaItem;
